exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.campaign-table-container[data-v-34f5a6c4]{overflow:visible}@media (max-width:767px){div.campaign-table-container[data-v-34f5a6c4]{overflow-x:auto}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-34f5a6c4","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/clients/AdAccountCampaignList.vue
// module id = Vq7M
// module chunks = 0